module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921084149_T.89b32cec.jpg";